<icon-app
  name="coins"
  [class.w-6]="size() === 'normal'"
  [class.w-4]="size() === 'small'" />
<p
  class="text-primary-900"
  [class.md:preset-title-4]="size() === 'normal'"
  [class.preset-title-5]="size() === 'normal'"
  [class.md:preset-title-5]="size() === 'small'"
  [class.preset-title-6]="size() === 'small'">
  {{ coins() | compactNumber }} {{ type() }}
</p>
